__turbopack_context__.v({
  "contact": "contact_form-module__tzPYzW__contact",
  "contact_content": "contact_form-module__tzPYzW__contact_content",
  "contact_content_form": "contact_form-module__tzPYzW__contact_content_form",
  "contact_content_other_block": "contact_form-module__tzPYzW__contact_content_other_block",
  "contact_content_other_block__title": "contact_form-module__tzPYzW__contact_content_other_block__title",
  "contact_content_other_block__value": "contact_form-module__tzPYzW__contact_content_other_block__value",
  "contact_results_form": "contact_form-module__tzPYzW__contact_results_form",
  "contact_results_form_icon": "contact_form-module__tzPYzW__contact_results_form_icon",
  "contact_results_form_text": "contact_form-module__tzPYzW__contact_results_form_text",
  "contact_results_icon__error": "contact_form-module__tzPYzW__contact_results_icon__error",
  "contact_results_icon__success": "contact_form-module__tzPYzW__contact_results_icon__success",
  "contact_send": "contact_form-module__tzPYzW__contact_send",
  "contact_send_conditions": "contact_form-module__tzPYzW__contact_send_conditions",
  "contact_send_conditions_description": "contact_form-module__tzPYzW__contact_send_conditions_description",
  "contact_title": "contact_form-module__tzPYzW__contact_title",
  "fit_layout__content": "contact_form-module__tzPYzW__fit_layout__content",
});
